import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1570. 見積タスクファイル削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_documents/:quotation_task_document_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const destroyQuotationTaskDocument = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_documents/${props.id}`
  );
};

export const useDestroyQuotationTaskDocument = () => {
  return useMutation({
    mutationFn: destroyQuotationTaskDocument
  });
};
